import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelArrowDownContainer = styled.div<React.CSSProperties>`
  bottom: ${30 * Screen.widthRatio}px;
  cursor: pointer;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  width: ${46 * Screen.widthRatio}px;
`;

export default ChannelArrowDownContainer;
